var styleDataHash = "9d952130";
const injectCss = () => {
  var css = `._2HNk2,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.BPk09{align-items:center;background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-color-text-standard-primary,var(--wsr-color-D10,#000624));cursor:pointer;display:flex;min-height:36px;padding-block:var(--ricos-internal-list-item-select-padding-block,6px);padding-inline:var(--ricos-internal-list-item-select-padding-inline,18px);--wds-color-text-standard-secondary:var(
    --wds-list-item-select-subtitle,var(--wsr-color-D40,#868aa5)
  )}.BPk09:hover{background-color:var(--wds-list-item-select-fill-hover,var(--wsr-color-B50,#e7f0ff))}.BPk09.BGr1H,.BPk09:active{background-color:var(--wds-list-item-select-active-fill,var(--wsr-color-B10,#116dff));--wds-color-text-standard-primary:var(
    --wds-list-item-select-active-title,var(--wsr-color-D80,#fff)
  );--wds-color-text-standard-secondary:var(
    --wds-list-item-select-active-subtitle,var(--wsr-color-D80,#fff)
  )}.BPk09.BGr1H:hover{background-color:var(--wds-list-item-select-active-fill-hover,var(--wsr-color-B20,#5999ff))}.BPk09._5vzcz{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-list-item-select-title-disabled,var(--wsr-color-D10-30,rgba(0,6,36,.3)));cursor:auto;pointer-events:none}.BPk09:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.BPk09.qovfT{--wds-font-size-body-medium:16px}.BPk09.tMz7o{min-height:54px}.MHJ7P{column-gap:6px;display:grid;flex:1;grid-template-areas:"prefix title suffix";grid-template-columns:max-content 1fr max-content;grid-template-rows:auto auto}.tMz7o{grid-template-areas:"prefix title suffix" "prefix subtitle suffix"}.QjhAV{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:prefix}._86kCY{align-self:center;grid-area:title}._86kCY,._9CnQa{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._9CnQa{grid-area:subtitle}.RwHEB{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:suffix}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "_2HNk2",
  "root": "BPk09",
  "selected": "BGr1H",
  "disabled": "_5vzcz",
  "mobile": "qovfT",
  "withSubtitle": "tMz7o",
  "content": "MHJ7P",
  "prefix": "QjhAV",
  "title": "_86kCY",
  "subtitle": "_9CnQa",
  "suffix": "RwHEB"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
